import { EPL_TEAMS } from "@/data/merchCups";
import { calculateOrderTotal, formatKes } from "@/lib/merchPricing";

function lineDescription(row) {
    if (!row.team) return "Plain (no sticker)";
    const team = EPL_TEAMS.find((t) => t.id === row.team)?.name || row.team;
    if (row.name) return `${team} + name “${row.name}”`;
    return `${team} (sticker only)`;
}

export default function OrderSummary({ packs, cupLines, colorName }) {
    const totals = calculateOrderTotal(packs, cupLines);

    return (
        <div className="rounded-2xl border border-zinc-200 bg-white p-5 sm:p-6 space-y-4">
            <h3 className="font-display font-bold text-lg text-zinc-950">
                Order summary
            </h3>
            <p className="text-sm text-zinc-600">
                {totals.packs} pack{totals.packs !== 1 ? "s" : ""} × 5 cups
                {colorName ? ` · ${colorName}` : ""}
            </p>
            <ul className="text-sm space-y-1.5 max-h-48 overflow-y-auto">
                {totals.perCupBreakdown.map((row) => (
                    <li
                        key={row.index}
                        className="flex justify-between gap-2 text-zinc-700"
                    >
                        <span>
                            Cup {row.index}: {lineDescription(row)}
                        </span>
                        <span className="tabular-nums shrink-0">
                            {formatKes(row.lineKes)}
                        </span>
                    </li>
                ))}
            </ul>
            <div className="pt-3 border-t border-zinc-100 flex justify-between items-baseline">
                <span className="font-medium text-zinc-950">Total</span>
                <span className="font-display text-2xl font-bold text-[#E54D2E] tabular-nums">
                    {formatKes(totals.subtotalKes)}
                </span>
            </div>
            <p className="text-xs text-zinc-500">
                KES 20 plain · +KES 20 team sticker (40) · +KES 10 custom name on
                sticker (50). Sold in packs of 5.
            </p>
        </div>
    );
}
